import { Wrapper } from '@american-autonomy/ag-ui';

import SingleSelectPanel from 'components/SingleSelectPanel';

import useData from './hooks/useData';
import useTranslation from './hooks/useTranslation';

import { ENTITY_TYPE, TEST_ID } from './constants';
import type { FunctionComponent, Item, Props } from './types';

const FieldSelectPanelField: FunctionComponent<Props> = ({
    className = '',
    farmId,
    onChange,
    onClose,
    testId = TEST_ID,
    value
}) => {
    const { SEARCH } = useTranslation();
    const { fieldItems, handleAsyncFilter, hasNextPage, isLoading, noItemsText, onNextPage } =
        useData(farmId);

    const handleClick = (field: Item) => {
        onChange(field);
        onClose?.(field);
    };

    return (
        <Wrapper className={className} testId={testId}>
            <SingleSelectPanel
                entityType={ENTITY_TYPE}
                hasNextPage={hasNextPage}
                isLoading={isLoading}
                itemSelected={value}
                items={fieldItems}
                label={SEARCH}
                noItemsFoundText={noItemsText}
                onFilter={handleAsyncFilter}
                onNextPage={onNextPage}
                onSelected={handleClick}
            />
        </Wrapper>
    );
};

export default FieldSelectPanelField;
